// Gsap
import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger, ScrollSmoother, ScrollToPlugin, SplitText);

export { gsap, DrawSVGPlugin, ScrollTrigger, ScrollSmoother, ScrollToPlugin, SplitText };
